@if (university(); as university) {
	<uc-main-header
		[heading]="headerTitle()"
		[description]="headerDescription()"
		[backgroundStyle]="
			isClearingView() ? 'bg-course-search-clearing' : 'bg-course-search'
		"
		textColor="text-white"
		descriptionColor="text-white"
	>
		<uc-course-search-bar
			class="block mt-8"
			[options]="degreeLevelOptions"
			[subject]="search()"
			[autoSuggestEnabled]="true"
			[disableError]="true"
			(enter)="onSearch($event)"
			placeholder="Search Courses"
			[searchLocation]="headerSearchBar"
		/>
	</uc-main-header>

	@if (university.courses) {
		<div
			id="course-search-container"
			class="container py-12 sm:pt-12 sm:pb-16 lg:overflow-visible"
		>
			<div class="flex justify-between w-full">
				<uc-course-search-filter
					class="flex-shrink-0 block lg:flex course-search-filter"
					[ngClass]="{
						open: filterTogglerSrv.displayFilter,
					}"
					[degree]="studyLevel()"
					[subject]="search()"
					[studyMode]="mode()"
					[ucasPoints]="ucaspts()"
					[uniSlug]="uni()"
					[showDegreeLevel]="false"
					[showLocation]="false"
					[disableError]="true"
					[isUniCourseSearch]="true"
					(filterChange)="updatePayloadAndFetchCourses($event)"
					(filterReset)="onFilterReset()"
					(autosuggest)="onSearch($event)"
					(closeFilter)="filterTogglerSrv.toggle(false)"
					(clearingChange)="onStudyLevelChange('clearing')"
					[isClearingSearch]="isClearingView()"
				/>

				<main class="w-full">
					@if (isLoading()) {
						<uc-universities-skeleton [filter]="false" />
					} @else {
						<div class="flex-grow w-full search-container">
							@if (university.courses.data?.length) {
								<uc-filter-sort-widget
									[total]="university.courses.total"
									[totalPills]="filterPillsCount()"
									text="courses found"
									[studyLevel]="studyLevel()"
									(toggleFilter)="filterTogglerSrv.toggle()"
								/>
							}
							<uc-course-search-result
								[resultLength]="university.courses.data?.length"
								[showIndividualUniCourses]="true"
								[product]="studyLevel()"
								(studyLevelChange)="onStudyLevelChange($event)"
							>
								@if (isClearingView() && cleUni()) {
									<uc-course-list-clearing-uni
										[searchTerm]="search()"
										[courses]="university.courses.data ?? []"
										[uniName]="university.name"
										[uniSlug]="university.slug"
										[uniId]="university.id"
										[uniLogo]="university.logo ?? ''"
										[uniCoverImage]="university.cover_image ?? ''"
										[cleSearchOrderPosition]="cleUni()?.order!"
										[externalUrl]="university.external_url"
										[uniPhoneNumber]="cleUni()?.phone_number ?? ''"
										[clientFeatures]="university.paid_features ?? []"
										[isFavourite]="university.saved"
										[recommendedPercentage]="
											university.recommended_percentage
										"
										[privacyPolicyUrl]="
											university.privacy_policy_url ?? ''
										"
									/>
								} @else if (!isClearingView()) {
									<uc-course-list-uni
										[product]="studyLevel()"
										[searchTerm]="search()"
										[courses]="university.courses.data ?? []"
										[uniId]="university.id"
										[uniName]="university.name"
										[uniSlug]="university.slug"
										[uniLogo]="university.logo ?? ''"
										[uniCoverImage]="university.cover_image ?? ''"
										[externalUrl]="university.external_url"
										[externalProspectusUrl]="
											university.external_prospectus_url ?? ''
										"
										[clientFeatures]="university.paid_features ?? []"
										[isFavourite]="university.saved"
										[recommendedPercentage]="
											university.recommended_percentage
										"
										[privacyPolicyUrl]="
											university.privacy_policy_url ?? ''
										"
										[ugSearchOrderPosition]="university.order"
									/>
								}
							</uc-course-search-result>

							@if (showLoadMore()) {
								<uc-course-search-pagination
									[hasMorePages]="!!university.courses.has_more_pages"
									[isLoading]="isPaginationLoading()"
									[searchTerm]="search()"
									[page]="university.courses.current_page"
									(loadMore)="onLoadMore($event)"
								/>
							}
						</div>
					}
				</main>
			</div>
		</div>
	}
} @else if (isLoading() && university() === null) {
	<uc-universities-skeleton class="container block" />
}
